export interface Category {
  id: string;
  name: string;
  namePl: string;
  url: string;
  productCount: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    productCount: "1,250+ produktów",
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    productCount: "890+ produktów",
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    productCount: "1,100+ produktów",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    productCount: "720+ produktów",
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    productCount: "640+ produktów",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePl: "Nakrycia głowy",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    productCount: "380+ produktów",
  },
  {
    id: "sets",
    name: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    productCount: "210+ produktów",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    productCount: "450+ produktów",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePl: "Koszulki sportowe",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    productCount: "320+ produktów",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    productCount: "560+ produktów",
  },
  {
    id: "bags",
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    productCount: "290+ produktów",
  },
  {
    id: "belts",
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    productCount: "180+ produktów",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    productCount: "150+ produktów",
  },
  {
    id: "other",
    name: "Other Stuff",
    namePl: "Inne",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    productCount: "340+ produktów",
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com";